import { render, staticRenderFns } from "./Texty.vue?vue&type=template&id=c4c12e76&"
import script from "./Texty.vue?vue&type=script&lang=ts&"
export * from "./Texty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports